import { Stack } from '@/common/components/Stack/Stack';
import { styles } from './BulletsLoading.styles';
import { View } from 'react-native';

export const BulletsLoading = ({ size = 'md' }: IBulletsLoadingProps) => {
  return (
    <Stack align="center" justify="center" gap="xs" horizontal>
      <View className={styles.bullet({ size, n: 0 })}></View>
      <View className={styles.bullet({ size, n: 1 })}></View>
      <View className={styles.bullet({ size, n: 2 })}></View>
      <View className={styles.bullet({ size, n: 3 })}></View>
      <View className={styles.bullet({ size, n: 4 })}></View>
    </Stack>
  );
};

export interface IBulletsLoadingProps {
  size?: 'sm' | 'md' | 'lg';
}
